"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _types = require("./types");
var ActivityWatcher = /*#__PURE__*/function () {
  function ActivityWatcher() {
    (0, _classCallCheck2.default)(this, ActivityWatcher);
  }
  return (0, _createClass2.default)(ActivityWatcher, null, [{
    key: "getTokenRefreshIsGoingOn",
    value: function getTokenRefreshIsGoingOn(type) {
      return ActivityWatcher.storage["".concat(type, "TokenRefreshIsGoingOn")];
    }
  }, {
    key: "setTokenRefreshIsGoingOn",
    value: function setTokenRefreshIsGoingOn(type, value) {
      ActivityWatcher.storage["".concat(type, "TokenRefreshIsGoingOn")] = value;
    }
  }, {
    key: "getLastTokenRefresh",
    value: function getLastTokenRefresh(type) {
      return ActivityWatcher.storage["".concat(type, "TokenRefresh")];
    }
  }, {
    key: "setLastTokenRefresh",
    value: function setLastTokenRefresh(type, value) {
      ActivityWatcher.storage["".concat(type, "TokenRefresh")] = value;
    }
  }, {
    key: "setStorage",
    value: function setStorage() {
      var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : localStorage;
      ActivityWatcher.storage = storage;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return new Date().getTime() / 1000 * 1;
    }
  }, {
    key: "getLastActivtyTimestamp",
    value: function getLastActivtyTimestamp() {
      return ActivityWatcher.storage.lastActivityTimestamp;
    }
  }, {
    key: "registerNewActivity",
    value: function registerNewActivity() {
      ActivityWatcher.storage.lastActivityTimestamp = this.getCurrentTime();
    }
  }, {
    key: "registerTokenRefreshing",
    value: function registerTokenRefreshing() {
      var _this = this;
      for (var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++) {
        types[_key] = arguments[_key];
      }
      types.forEach(function (type) {
        ActivityWatcher.setLastTokenRefresh(type, _this.getCurrentTime());
        ActivityWatcher.setTokenRefreshIsGoingOn(type, undefined);
      });
    }
  }, {
    key: "cleanupLocalData",
    value: function cleanupLocalData() {
      Object.values(_types.tokenTypes).forEach(function (type) {
        ActivityWatcher.setLastTokenRefresh(type, undefined);
        ActivityWatcher.setTokenRefreshIsGoingOn(type, undefined);
      });
      ActivityWatcher.storage.lastActivityTimestamp = "";
    }
  }, {
    key: "calculateLastActivityInterval",
    value: function calculateLastActivityInterval() {
      return this.getCurrentTime() - parseInt(this.getLastActivtyTimestamp(), 10);
    }
  }, {
    key: "registerActivityListeners",
    value: function registerActivityListeners() {
      var _this2 = this;
      var eventCalculator = function eventCalculator() {
        if (_this2.calculateLastActivityInterval() > 5) {
          _this2.registerNewActivity();
          _this2.refreshTokens();
        }
      };
      window.addEventListener("mousemove", eventCalculator);
      window.addEventListener("touchend", eventCalculator);
      window.addEventListener("touchstart", eventCalculator);
      window.addEventListener("touchmove", eventCalculator);
      window.addEventListener("scroll", eventCalculator);
      window.addEventListener("keypress", eventCalculator);
    }
  }, {
    key: "itHasValidLocks",
    value: function itHasValidLocks(type) {
      var tokenTimer = ActivityWatcher.getTokenRefreshIsGoingOn(type);
      return tokenTimer && this.getCurrentTime() - tokenTimer < 60;
    }
  }, {
    key: "refreshTokens",
    value: function refreshTokens() {
      var _this3 = this;
      var timeToUpdateToken = function timeToUpdateToken(lastTokenRefresh, interval) {
        return _this3.getCurrentTime() - lastTokenRefresh > interval / 2;
      };
      ActivityWatcher.tokenRefreshers.forEach(function (tokenRefresh) {
        var lastRefresh = ActivityWatcher.getLastTokenRefresh(tokenRefresh.type) || 0;
        if (timeToUpdateToken(lastRefresh, tokenRefresh.interval) && !_this3.itHasValidLocks(tokenRefresh.type)) {
          ActivityWatcher.setTokenRefreshIsGoingOn(tokenRefresh.type, _this3.getCurrentTime());
          tokenRefresh.call().then(function () {
            _this3.registerTokenRefreshing(tokenRefresh.type);
          }).catch(function () {
            ActivityWatcher.setTokenRefreshIsGoingOn(tokenRefresh.type, undefined);
          });
        }
      });
    }

    /**
     * @param timoeoutInterval Interval in seconds that defines how long user can be inactive
     * @param givenTokenRefreshers Array of TokenRefreshXhrs, see the doc in the types.ts
     * @param sessionTerminator Callback for terminating the session
     * @returns void
     */
  }, {
    key: "initActivityObserving",
    value: function initActivityObserving() {
      var _this4 = this;
      var timoeoutInterval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 540;
      var givenTokenRefreshers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var sessionTerminator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      if (this.activityObserver) {
        return;
      }
      this.tokenRefreshers = givenTokenRefreshers;
      this.registerActivityListeners();
      var observer = function observer() {
        var lastActivityHappened = _this4.calculateLastActivityInterval();
        if (isNaN(lastActivityHappened) || lastActivityHappened > timoeoutInterval) {
          ActivityWatcher.cleanupLocalData();
          sessionTerminator();
          if (_this4.activityObserver) {
            clearInterval(_this4.activityObserver);
          }
        }
      };
      this.activityObserver = setInterval(observer, 5000);
      observer();
    }
  }, {
    key: "clearObserver",
    value: function clearObserver() {
      if (this.activityObserver) {
        clearInterval(this.activityObserver);
        delete this.activityObserver;
      }
    }
  }]);
}();
(0, _defineProperty2.default)(ActivityWatcher, "activityObserver", void 0);
(0, _defineProperty2.default)(ActivityWatcher, "tokenRefreshers", void 0);
(0, _defineProperty2.default)(ActivityWatcher, "storage", void 0);
var _default = exports.default = ActivityWatcher;